import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import PropTypes from 'prop-types';
/**
 * Use `OrderStatus` to display a badge with human-friendly text describing the current order status.
 *
 * @return { object } -
 */

var OrderStatus = function OrderStatus(_ref) {
  var order = _ref.order,
      className = _ref.className,
      orderStatusMap = _ref.orderStatusMap;
  var status = order.status;
  var classes = classnames('woocommerce-order-status', className);
  var indicatorClasses = classnames('woocommerce-order-status__indicator', _defineProperty({}, 'is-' + status, true));
  var label = orderStatusMap[status] || status;
  return createElement("div", {
    className: classes
  }, createElement("span", {
    className: indicatorClasses
  }), label);
};

OrderStatus.propTypes = {
  /**
   * The order to display a status for.
   */
  order: PropTypes.object.isRequired,

  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * A map of status to label for order statuses.
   */
  orderStatusMap: PropTypes.object
};
export default OrderStatus;
//# sourceMappingURL=index.js.map